import { API_AUTH, API_AUTH_FILE } from "./common";

const ChoVayApi = {
  canhbaoSoLuongHopDong: () => API_AUTH.get(`cho-vay/canh-bao-so-hop-dong`, {}),
  getDanhSachNo: (params) => API_AUTH.get(`quan-ly-cho-vay/danhsachno`, params),
  xuatBaoCaoDanhSachNo: (params) => API_AUTH_FILE.get(`quan-ly-cho-vay/xuat-bao-cao-danh-sach-no`, params, { responseType: 'blob' }),
};

export default ChoVayApi;
